/* eslint-disable indent */
import { autoInjectable } from 'tsyringe';
import AxiosHttpClient from '../../Network/AxiosHttpClient';
import VrObject3D from '../Three/VrObject3D';
import { Block, Text } from 'three-mesh-ui';

import FontJSON from '@assets/fonts/Roboto-Regular-msdf.json';
import FontImage from '@assets/fonts/Roboto-Regular.png';

import Camera from '../../Camera';
import Time from '../../Utils/Time';
import Resources from '../../Resources';
import {
    Color,
    DoubleSide,
    MeshPhongMaterial,
    RepeatWrapping,
    TextureLoader,
} from 'three';
import Controlls from '../Controllers/Controlls';
import IntersectionContainer from '../Controllers/IntersectionContainer';
import IconScrollUpWhite from '../../../../static/assets/icons/icon-name-scroll-up-white-full.png';
import IconScrollDownWhite from '../../../../static/assets/icons/icon-name-scroll-down-white-full.png';
import Utils from '../../Utils/Utils';
import IconCourseCover from '../../../../static/assets/icons/icon-name-book.png';
import { MaskLoader } from './MaskLoader';
import IMyContent from '../../Network/Models/My_content/IMyContent';
import { AxiosResponse } from 'axios';
import { Coursebook } from './Coursebook';
import CourseView from './CourseView';

import { Text as TText } from 'troika-three-text';
//@ts-ignore
import robot from '../../../../static/Roboto/Roboto-Regular.ttf';
import TranslationService from '../../Translations/TranslationService';
export const hoveredStateAttributes = {
    state: 'hovered',
    attributes: {
        offset: 0.035,
        backgroundColor: new Color(0x1847c9),
        backgroundOpacity: 1,
        fontColor: new Color(0xffffff),
    },
};

export const idleStateAttributes = {
    state: 'idle',
    attributes: {
        backgroundColor: new Color('black'),
    },
};

export const clickStateAttributes = {
    state: 'selected',
    attributes: {
        backgroundOpacity: 1,
        backgroundColor: new Color('lightblue'),
        offset: 0.06,
    },
};

@autoInjectable()
export class MyContent extends VrObject3D {
    public container: Block;
    public courses: AxiosResponse<IMyContent[]>;

    public mask: boolean = true;
    public containerMask: MaskLoader;

    public constructor(
        public httpClient?: AxiosHttpClient,
        public intersectionContainer?: IntersectionContainer,
        public controls?: Controlls,
    ) {
        super();

        this.fetchCourses();

        this.setLabel();
    }

    public disableShadows() {}

    public setDefaultState(block: Block, click?: Function) {
        let selectedAttribute: any = {
            state: 'selected',
            attributes: {
                backgroundColor: new Color(0xffffff),
                backgroundOpacity: 0.1,
            },
        };

        if (click) {
            selectedAttribute = {
                state: 'selected',
                attributes: {
                    backgroundColor: new Color(0xffffff),
                    backgroundOpacity: 0.1,
                },
                onSet: () => {
                    click();
                },
            };
        }

        //@ts-ignore
        block.setupState({
            state: 'idle',
            attributes: {
                backgroundOpacity: 0.001,
            },
        });
        //@ts-ignore
        block.setupState({
            state: 'hovered',
            attributes: {
                backgroundColor: new Color(0xffffff),
                backgroundOpacity: 0.1,
            },
        });

        //@ts-ignore
        block.setupState(selectedAttribute);
    }

    public setLabel() {
        const myContentLabel = new TText();

        myContentLabel.text = TranslationService.translate('vr.my_content');
        myContentLabel.fontSize = 0.2;
        myContentLabel.color = 0x4899b1;
        myContentLabel.anchorX = 'center';
        myContentLabel.anchorY = 'middle';
        myContentLabel.depthOffset = 0.1;
        myContentLabel.material = new MeshPhongMaterial({
            color: new Color('#4899b1'),
            emissive: new Color('#4899b1'),
            emissiveIntensity: 1,
            side: DoubleSide,
        });
        myContentLabel.position.x = -1.6;
        myContentLabel.position.y = 1.6;
        myContentLabel.position.z = 0;
        myContentLabel.font = robot;

        this.add(myContentLabel);
    }

    public async fetchCourses() {
        if (this.mask) {
            const containerMask = new MaskLoader();
            containerMask.position.z = 0.15;
            this.add(containerMask);
            this.containerMask = containerMask;
        }

        try {
            this.courses = await this.httpClient.getCourseCollection();
            this.mask = false;
        } catch (err) {
            console.log('Error w pobieraniu danych');
        }

        if (!this.mask) {
            this.containerMask.removeMask();
        }

        let borderWidth = 0.01;
        let borderColor = new Color(0xffffff);
        let borderOpacity = 0.8;
        let offsetActiveObj = 0.03;
        // let offsetActiveObj = 0.07;

        if (this.courses.data.length > 0) {
            //MAIN CONTAINER
            this.container = new Block({
                width: 4.2,
                // width: 8,
                // height: 4.5,
                height: 2.5,
                opacity: 1,
                fontFamily: FontJSON,
                fontTexture: FontImage,
                hiddenOverflow: true,
                backgroundOpacity: 0,
                borderRadius: 0,
                borderWidth: borderWidth,
                borderColor: borderColor,
                borderOpacity: 0,
                // padding: 0.05,
            });

            this.container.userData.type = 'ui-board';
            this.container.userData.id = 'ui-board';
            // this.intersectionContainer.addObjectToIntersect(
            //     this.container,
            //     true,
            //     false,
            // );
            this.setDefaultState(this.container);

            // wrapper for vertical scroll
            const containerWrapper = new Block({
                // width: 7.8,
                width: 4.2,
                height: 2.5,
                // height: 4.3,
                contentDirection: 'row',
                alignItems: 'start',
                hiddenOverflow: true,
                backgroundOpacity: 0,
                borderRadius: 0,
                borderWidth: 0,
                borderOpacity: 0,
            });
            this.container.add(containerWrapper);

            const mainContent = new Block({
                // width: 7.6,
                // height: 4.3,
                width: 4,
                height: 2.5,
                backgroundOpacity: 0,
                borderWidth: 0,
                offset: 0.0001, //
            });

            const verticalScrollWrapper = new Block({
                width: 0.2,
                // height: 4.3,
                height: 2.5,
                contentDirection: 'column',
                alignItems: 'right',
                backgroundOpacity: 0,
                borderWidth: 0,
                offset: 0.0001, //
            });

            containerWrapper.add(mainContent, verticalScrollWrapper);

            // btns for verticalScrollWrapper
            const btnScrollOptions = {
                width: 0.1,
                height: 0.1,
                offset: offsetActiveObj,
                backgroundOpacity: 0,
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 0,
                borderWidth: borderWidth,
                borderColor: borderColor,
                borderOpacity: borderOpacity,
            };

            const btnScrollUp = new Block(btnScrollOptions);
            const btnScrollDown = new Block(btnScrollOptions);

            // IconScrollUpWhite
            new TextureLoader().load(IconScrollUpWhite, (texture) => {
                btnScrollUp.add(
                    new Block({
                        width: 0.08,
                        height: 0.08,
                        backgroundTexture: texture,
                        borderWidth: 0,
                    }),
                );
            });
            // IconScrollDownWhite
            new TextureLoader().load(IconScrollDownWhite, (texture) => {
                btnScrollDown.add(
                    new Block({
                        width: 0.08,
                        height: 0.08,
                        backgroundTexture: texture,
                        borderWidth: 0,
                    }),
                );
            });

            const panelScrollSpace = new Block({
                width: 0.2,
                // height: 4.1,
                height: 2.3,
                backgroundOpacity: 0,
                borderWidth: 0,
                borderOpacity: 0,
            });

            verticalScrollWrapper.add(
                btnScrollUp,
                panelScrollSpace,
                btnScrollDown,
            );

            this.setDefaultState(btnScrollUp, () => {
                if (mainContent.position.y <= 0) {
                    return;
                }
                // @ts-ignore
                mainContent.position.y === 0
                    ? (mainContent.position.y += 0)
                    : (mainContent.position.y -= 0.2);
                //@ts-ignore
                mainContent.position.y <= -mainContent.size.y ||
                mainContent.position.y <= 0
                    ? (mainContent.position.y -= 0)
                    : (mainContent.position.y -= 0.1);
            });
            this.setDefaultState(btnScrollDown, () => {
                // @ts-ignore
                let _maxScroll = 0;
                // @ts-ignore
                for (let i = 0; i < mainContent.childrenBoxes.length; i++) {
                    // @ts-ignore
                    _maxScroll += mainContent.childrenBoxes[i].height;
                }

                mainContent.position.y < _maxScroll - 0.4
                    ? (mainContent.position.y += 0.1)
                    : (mainContent.position.y += 0);
            });

            this.intersectionContainer.addObjectToIntersect(
                btnScrollUp,
                false,
                true,
            );
            this.intersectionContainer.addObjectToIntersect(
                btnScrollDown,
                false,
                true,
            );

            //--
            //collect all course name
            let all = [];

            this.courses.data.forEach((courses) => {
                //@ts-ignore
                courses.collections.forEach((course) => {
                    all.push(course);
                });
            });

            //@ts-ignore
            all.sort((a, b) => {
                //@ts-ignore
                if (
                    b.title.trim().toLowerCase() > a.title.trim().toLowerCase()
                ) {
                    return -1;
                    //@ts-ignore
                } else if (
                    b.title.trim().toLowerCase() < a.title.trim().toLowerCase()
                ) {
                    return 1;
                } else {
                    return 0;
                }
            });

            all.forEach((courseSet) => {
                //blok z kursem
                const courseBlock = new Block({
                    // width: 7.6,
                    width: 4,
                    height: 0.3,
                    contentDirection: 'row',
                    backgroundOpacity: 0,
                    hiddenOverflow: true,
                    borderRadius: 0,
                    borderWidth: borderWidth,
                    borderColor: borderColor,
                    borderOpacity: borderOpacity,
                });

                const courseCover = new Block({
                    width: 0.6,
                    height: 0.3,
                    justifyContent: 'center',
                    backgroundOpacity: 0,
                    borderWidth: 0,
                    borderOpacity: 0,
                });

                new TextureLoader().load(IconCourseCover, (texture) => {
                    courseCover.add(
                        new Block({
                            width: 0.16,
                            height: 0.16,
                            backgroundTexture: texture,
                        }),
                    );
                });

                const courseTitle = new Block({
                    // width: 7,
                    width: 3.2,
                    height: 0.3,
                    fontSize: 0.08,
                    textAlign: 'left',
                    justifyContent: 'center',
                    fontFamily: FontJSON,
                    fontTexture: FontImage,
                    borderRadius: 0,
                    backgroundOpacity: 0,
                    borderWidth: 0,
                    borderOpacity: 0,
                });

                const courseTitleText = new Text({
                    content:
                        courseSet.title === 'api.courses.unassigned_courses'
                            ? 'Unassigned CoursesPanel'
                            : Utils.stripNonAplhaNumericAndHtml(
                                  courseSet.title,
                              ),
                });

                courseTitle.add(courseTitleText);

                const space = new Block({
                    // width: 7.6,
                    width: 4,
                    height: 0.02,
                    borderWidth: 0,
                    borderOpacity: 0,
                    backgroundOpacity: 0,
                });

                courseBlock.add(courseCover, courseTitle);

                this.intersectionContainer.addObjectToIntersect(
                    courseBlock,
                    false,
                    true,
                );
                this.setDefaultState(courseBlock, () => {
                    // @ts-ignore
                    const courseView = new CourseView(courseSet);
                    courseView.position.z = offsetActiveObj + 0.02;
                    // courseView.translateY(-0.1);

                    // @ts-ignore
                    this.add(courseView);
                });

                mainContent.add(courseBlock, space);
            });
        }

        this.add(this.container);

        this.container.traverse((block) => {
            if (block.name === 'MeshUI-Frame') {
                block.castShadow = false;
                block.receiveShadow = false;
            }
        });
    }
}

@autoInjectable()
export default class DockView extends VrObject3D {
    public container: Block;

    public constructor(
        public camera?: Camera,
        public resources?: Resources,
        public controls?: Controlls,
        public intersectionContainer?: IntersectionContainer,
    ) {
        super();

        const verticalAttributes = {
            state: 'vertical',
            attributes: {
                width: 1,
                height: 2.5,
                contentDirection: 'column',
                justifyContent: 'space-between',
            },
        };

        const horizontalAttributes = {
            state: 'horizontal',
            attributes: {
                width: 5,
                height: 0.5,
                justifyContent: 'space-between',
                contentDirection: 'row',
            },
        };

        this.container = new Block({
            width: 5,
            height: 0.5,
            borderRadius: 0,
            contentDirection: 'row',
            backgroundOpacity: 0.9,
            padding: 0.2,
        });

        //@ts-ignore
        this.container.setupState(horizontalAttributes);

        //@ts-ignore
        this.container.setupState(verticalAttributes);

        this.add(this.container);
    }

    public update(_time?: Time): void {}
}
